import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AccountInfo} from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly _username = new BehaviorSubject<AccountInfo | null>(null);

  public readonly username$: Observable<AccountInfo | null> = this._username.asObservable();

  public setUsername(username: AccountInfo | null): void {
    this._username.next(username);
  }

  public getUser(): AccountInfo | null {
    return this._username.value;
  }

  public clearUsername(): void {
    this._username.next(null);
  }

}
